'use client';
import React from 'react';
import Image from 'next/image';
import ContactForm from '@/components/common/contact-form';
import dynamic from 'next/dynamic';

const KEY = dynamic(() => import('@/components/common/keylist'));

const UsaRequestMeeting = () => {
    return (
        <section id="request-meeting" className="section-py dark:bg-black bg-light-grey">
            <div className="container lg:container mx-auto">
                <div className="row grid md:grid-cols-12 gap-8 items-start">
                    {/* Left: Form */}
                    <ContactForm
                        wrapperClassName="md:col-span-7 lg:col-span-7"
                        title="Request a 1:1 Meeting During Deep's USA Visit"
                        subtitle={
                            <span>
                                Share your business priorities, AI goals, or modernization challenges. Our team will coordinate a
                                suitable meeting slot during 7 May to 27 June 2026.
                            </span>
                        }
                        requestFromPage="lets-meet-usa"
                    />

                    {/* Right: Info */}
                    <div className="md:col-span-5 lg:col-span-5 flex flex-col gap-6">
                        {/* Deep's Image */}
                        <div
                            className="bg-white dark:bg-[#3C456133] dark:border-[#ffffff33] dark:border dark:border-solid dark:text-light rounded-lg p-6 text-center"
                            data-aos="fade-up"
                            data-aos-duration={1000}
                            data-aos-delay={200}
                        >
                            <Image
                                src="/img/lets-meet-usa/deep-trivedi-at-usa.svg"
                                alt="Deep Trivedi at USA"
                                width={200}
                                height={200}
                                className="mx-auto mb-5 rounded-10 object-cover"
                                loading="lazy"
                            />
                            <h2 className="text-primary mb-4">Deep Trivedi</h2>
                            <div className="fw-700 text-md text-white">
                                Building secure, scalable digital solutions that{' '}
                                <div> transform operations and accelerate growth.</div>
                            </div>
                        </div>

                        <div
                            className="bg-white dark:bg-[#3C456133] dark:border-[#ffffff33] dark:border dark:border-solid rounded-lg lg:py-6 px-5 md:px-5 lg:px-35 experience-section relative overflow-hidden"
                            data-aos="fade-up"
                            data-aos-duration={1000}
                        >
                            <div className="rating-section relative z-10 py-6 lg:py-0">
                                <KEY text="18+ years of industry experience" className="text-textcolor" />
                                <KEY text="500+ global clients" className="text-textcolor" />
                                <KEY text="Transparent cost" className="text-textcolor" />
                                <KEY text="Quick product delivery" className="text-textcolor" />
                                <KEY text="Team ownership" className="text-textcolor" />
                            </div>
                            <div className="lg:absolute mx:auto text-center rating-img bottom-[-1px] right-[-2px] z-0 lg:w-[42%]">
                                <Image
                                    alt="rating star"
                                    src="/img/lets-meet-usa/contact-info-usa.svg"
                                    height={221}
                                    width={221}
                                    loading="lazy"
                                    data-aos="fade-left"
                                    data-aos-duration={1000}
                                    data-aos-delay={100}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default UsaRequestMeeting;
